import toast from "react-hot-toast";
import {
  ComponentInputs,
  DocumentFileMap,
  SingleTemplate,
} from "../../../models/whatsappTemplate.model";
import {
  updateRoundRobinData,
  uploadtoS3,
} from "../../../store/slices/roundRobinSlice";
import { RootDispatch } from "../../../store";
import { ConfigInfo } from "../../../models/roundRobin.model";

// import { useDispatch } from "react-redux";

export const generateWhatsAppTemplatePayloadAndUploadToS3 = async (
  singleTemplate: SingleTemplate,
  documentFile: DocumentFileMap,
  componentInputs: ComponentInputs,
  configInfo: ConfigInfo,
  dispatch: RootDispatch
): Promise<{
  components: {
    type: string;
    parameters: {
      type: string;
      text?: string;
      document?: {
        link: string;
        filename: string;
      };
    }[];
  }[];
  fileInfo: {
    fileName: string;
    fileUrl: string;
  };
}> => {
  const template = singleTemplate?.template;
  const templateComponents = template?.components || [];

  const components: Array<{
    type: string;
    parameters: any[];
  }> = [];

  // ✅ declare fileInfo holder
  let fileInfo: { fileName: string; fileUrl: string } = {
    fileName: "",
    fileUrl: "",
  };

  for (const comp of templateComponents) {
    const { type, text = "", format } = comp;
    const upperType = type.toUpperCase();

    if (
      upperType === "HEADER" &&
      (format === "DOCUMENT" || format === "IMAGE")
    ) {
      const file = documentFile?.[upperType];
      if (!file) {
        toast.error("Please upload the required document or image.");
        throw new Error("Missing header file");
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await dispatch(uploadtoS3(formData)).unwrap();

        // ✅ Save into fileInfo
        fileInfo = {
          fileName: response.fileName,
          fileUrl: response.s3Location,
        };
        const updatedConfigInfo: ConfigInfo = {
          ...configInfo,
          documentUrl: response.s3Location,
          documentFilename: response.fileName,
        };
        await dispatch(updateRoundRobinData(updatedConfigInfo));
        components.push({
          type: "HEADER",
          parameters: [
            {
              type: format === "DOCUMENT" ? "document" : "image",
              document: {
                link: response.s3Location,
                filename: response.fileName,
              },
            },
          ],
        });
      } catch (err) {
        toast.error("Failed to upload file to S3.");
        throw err;
      }

      continue;
    }

    const holes = text.match(/{{\s*\d+\s*}}/g) || [];
    const parameters = holes.map((_, i) => ({
      type: "text",
      text: componentInputs[`${upperType}_${i + 1}`] || "",
    }));

    components.push({
      type: upperType,
      parameters,
    });
  }

  return {
    components,
    fileInfo,
  };
};
